export type TNullable<T> = T | null;

// Network types
export enum Transmission {
  Sender = 'sender',
  Receiver = 'receiver',
}
export interface ChatMessage {
  id: number;
  message: string;
  timestamp: Date;
  sender: string;
  transmission: Transmission;
  meta: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}
export enum NlpRequestType {
  Simple = 'simple',
  ChoiceSelection = 'choice_selection',
}
export interface INlpRequest {
  query: string;
  topicId: string;
  instanceId: string;
  conversationId: string;
  queryType: NlpRequestType;
}
export interface IDocument {
  id: string;
  displayName: string;
  createdAt: string;
  updatedAt: string;
  externalDocumentLink: string;
  hits: number;
  last_time_seen: string;
  content?: string;
}
export interface IQuestionOption {
  questionId: string;
  optionType: 'CERTAIN_OPTION' | 'UNCERTAIN_OPTION';
  actualQuery: string;
  answer: string;
  status: string;
  paraphrases: string[];
  sourceDocuments: Array<Pick<IDocument, 'id' | 'displayName' | 'externalDocumentLink'>>;
  similarity: number;
  references: IReference[];
}
export interface IQuery {
  id: string;
  query: string;
  processingTime: number;
  createdAt: string;
  updatedAt: string;
  question: string;
}
export interface INlpResponse {
  query?: Pick<IQuery, 'id' | 'query'>;
  questionOptions?: IQuestionOption[];
  error?: string;
  status?: number;
}
export interface IQueryLog {
  id: string;
  query: string;
  createdAt?: string;
  updatedAt?: string;
}
export interface ITopicGroup {
  id: string;
  name: string;
  synonyms: string[];
}
export interface ITopicTag {
  id: string;
  name: string;
}
export enum TopicStatus {
  Active = 'active',
  Inactive = 'inactive',
  Disabled = 'disabled',
}
export interface ITopic {
  id: string;
  name: string;
  displayName: string;
  legalName: string;
  status: TopicStatus;
  groupId: TNullable<string>;
  groupName: TNullable<string>;
  groupSynonyms: string[];
  tags: ITopicTag[];
  keywords: string[];
  docs: Array<{
    content: string;
    createdAt: string;
    displayName: string;
    enabled: boolean;
    externalUrl: string;
    filePath: string;
    id: string;
    name: string;
    topic: string;
    type: string;
    uniqueKey: string;
    updatedAt: string;
  }>;
}

export interface ISaveFeedbackRequest {
  queryId: string;
  questionId: string;
  value: string;
}
export enum MessageType {
  Response = 'response',
  Message = 'message',
  DisabledTopicMessage = 'disabledTopicMessage',
  Error = 'error',
  UserEntry = 'userentry',
  LiveChatUserEntry = 'liveChatUserEntry',
  LiveChatOperatorMessage = 'liveChatOperatorMessage',
  LiveChatNotice = 'liveChatNotice',
  ChoiceResponse = 'choiceResponse',
  NoAnswerResponse = 'noanswerresponse',
  ForceMedInfo = 'forcemedinfo',
  InvalidQuery = 'invalidQuery',
}
export interface IMessage {
  id: number;
  message: string;
  questionQuery?: string;
  type?: MessageType;
  questionId?: string;
  senderName?: string;
  choices?: IQuestionOption[];
  queryId?: string;
  references?: IReference[];
}

export type LiveChatStatus =
  | 'idle'
  | 'preparing'
  | 'routing'
  | 'running'
  | 'ending'
  | 'ended'
  | 'no-agent'
  | 'timeout'
  | 'agent-left'
  | 'failed';

export interface ILiveChatAgent {
  name: string;
  picture?: string;
}

export interface ILiveChat {
  enabled: boolean;
  status: LiveChatStatus;
  agent: TNullable<ILiveChatAgent>;
  isActive: boolean;
  canStart: boolean;
  canSend: boolean;
  start: (initialMessage?: string, customerName?: string) => Promise<void>;
  sendMessage: (message: string) => Promise<void>;
  end: () => Promise<void>;
}
export enum ReferenceType {
  Smpc = 'smpc',
  Article = 'article',
  Leaflet = 'leaflet',
  Web = 'web',
  Video = 'video',
}
export interface IReference {
  referenceType: ReferenceType;
  sourceDocumentId: string;
  headerId: string;
  headerTitle: TNullable<string>;
  externalDocumentLink: TNullable<string>;
  name: string;
}
export enum Feedback {
  Like = '1',
  Dislike = '0',
}
export interface IModalContent {
  title: string;
  text: string;
  userQuery?: string;
}
export enum Modals {
  MedicalInfo = 'medical-info',
}
export interface IPDFSection {
  title: string;
  section_number: string;
  page: number;
  coordinates: {
    x: number;
    y: number;
  };
  width: number;
  height: number;
  header_id: string;
}
export interface IPDFDetailsResponse {
  display_name: string;
  pdf_file_url: string;
  page_width: number;
  page_height: number;
  section_coordination_list: Array<IPDFSection>;
}
export interface IVideoDetailsResponse {
  videoUrl: TNullable<string>;
}
